// fetch forex deposits
export const FETCH_FOREX_DEPOSITS_REQUESTED = "FETCH_FOREX_DEPOSITS_REQUESTED";
export const FETCH_FOREX_DEPOSITS_SUCCESS = "FETCH_FOREX_DEPOSITS_SUCCESS";
export const FETCH_FOREX_DEPOSITS_FAIL = "FETCH_FOREX_DEPOSITS_FAIL";

export const ADD_FOREX_DEPOSIT_REQUESTED = "ADD_FOREX_DEPOSIT_REQUESTED";
export const ADD_FOREX_DEPOSIT_SUCCESS = "ADD_FOREX_DEPOSIT_SUCCESS";
export const ADD_FOREX_DEPOSIT_FAIL = "ADD_FOREX_DEPOSIT_FAIL";
export const ADD_FOREX_DEPOSIT_CLEAR = "ADD_FOREX_DEPOSIT_CLEAR";
export const ADD_FOREX_DEPOSIT_ERROR_CLEAR = "ADD_FOREX_DEPOSIT_ERROR_CLEAR";
export const APPROVE_FOREX_DEPOSIT = "APPROVE_FOREX_DEPOSIT";
export const APPROVE_FOREX_DEPOSIT_SUCCESS = "APPROVE_FOREX_DEPOSIT_SUCCESS";
export const REJECT_FOREX_DEPOSIT = "REJECT_FOREX_DEPOSIT";
export const REJECT_FOREX_DEPOSIT_SUCCESS = "REJECT_FOREX_DEPOSIT_SUCCESS";